"use strict";

import "core-js/modules/es.regexp.constructor.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.string.replace.js";
import match from 'autosuggest-highlight/match';
export const sanitiseString = value => (value || '').replace(String.fromCharCode(92), '') // Remove all \
.replace(/(^\s+)|(\s+$)|\\*|\W\s/g, '');
export const stringMatchWeight = (query, reference) => {
  var _match;
  return query !== null && query !== void 0 && query.length ? Number(new RegExp(`^${sanitiseString(query)}`, 'i').test(reference) ? 2 : new RegExp(`${sanitiseString(query)}`, 'ig').test(reference) ? 1 : 0) * 5 + Number((_match = match(reference, query)) === null || _match === void 0 ? void 0 : _match.length) : 1;
};